import { globalWindow } from './global';
export var isMiniAli = typeof my !== 'undefined' && !!my && typeof my.showToast === 'function';
export default !isMiniAli ? globalWindow.devicePixelRatio : my.getSystemInfoSync().pixelRatio;
//# sourceMappingURL=devicePixelRatio.js.map